<template>
  <li class="nav-item dropdown">
    <a
      href="#"
      class="nav-link dropdown-toggle"
      data-toggle="dropdown"
      data-v-step="myAccount"
    >
      <i class="fas fa-user mr-1"></i> My Account
    </a>
    <div class="dropdown-menu">
      <router-link
        :to="{ name: 'myAccount' }"
        class="dropdown-item"
        data-toggle="collapse"
        data-v-step="editClientProfile"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        >Edit Account</router-link
      >
      <div class="dropdown-divider"></div>
      <router-link
        :to="{ name: 'logout' }"
        class="dropdown-item"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        >Logout</router-link
      >
    </div>
  </li>
</template>
<script>
export default {
  name: "ClientNav",
  props: ["user"],
};
</script>
